var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "black",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_764_19210)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.05176e-05C7.45949 3.05176e-05 5.4 2.05952 5.4 4.60003V5H2.6C2.28877 5 2.02922 5.23797 2.00225 5.54802L1.08572 16.0882C0.902822 18.1915 2.5609 20 4.67219 20H15.3277C17.439 20 19.097 18.1915 18.9142 16.0882L17.9977 5.54803C17.9708 5.23797 17.7112 5 17.4 5H14.6V4.60003C14.6 2.05952 12.5405 3.05176e-05 10 3.05176e-05ZM13.4 6.2V9.39999C13.4 9.73137 13.6686 9.99999 14 9.99999C14.3314 9.99999 14.6 9.73137 14.6 9.39999V6.2H16.8499L17.7187 16.1921C17.8406 17.5944 16.7352 18.8 15.3277 18.8H4.67219C3.26466 18.8 2.15928 17.5944 2.28121 16.1921L3.15009 6.2H5.4V9.39999C5.4 9.73137 5.66863 9.99999 6 9.99999C6.33137 9.99999 6.6 9.73137 6.6 9.39999V6.2H13.4ZM13.4 5V4.60003C13.4 2.72226 11.8778 1.20003 10 1.20003C8.12223 1.20003 6.6 2.72226 6.6 4.60003V5H13.4Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_764_19210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.0c8d06a18c764826cc24bf3b4bce3df0.svg";
export { ForwardRef as ReactComponent };